import React, {useEffect, useState} from 'react';
import FunctionSidebarContainer from "../common/FunctionSidebar/FunctionSidebarContainer";
import Preloader from "../common/Preloader/Preloader";
import {FormControlCheckBoxes, GreenCheckbox} from "../ObjectRules/styles";
import {Field, Form, Formik} from "formik";
import AutoSaveWithDebounce from "../common/Autosave/AutoSaveWithDebounce";
import Box from "@material-ui/core/Box";
import StickyBottomButton from "../common/StickyBottomButtonSave/StickyBottomButton";
import SavingSnackbar from "../common/SavingSnackbar/SavingSnackbar";
import AlertSavePage from "../common/AlertSavePage/AlertSavePage";
import {useHistory} from "react-router-dom";


const ObjectRatePlans = (props) => {
    const {objectId, ratePlanList, savePage} = props
    const [initValue, setInitValue] = useState()
    const [preSavePage, setPreSavePage] = useState()
    const [unsavedPage, toggleUnsavedPage] = useState(false)
    const [targetRedirectLink, setTargetRedirectLink] = useState(false)
    const history = useHistory()

    useEffect(() => {
        if (ratePlanList) {
            let newInitValue = {}
                ratePlanList.map(item => {
                    newInitValue = {...newInitValue, [item.name]: item.active === "Y" ? true : false}
            })
            setInitValue(newInitValue)
        }
    }, [ratePlanList])


    const onSubmit = (values) => {
        let updateRatePlans = []
        Object.keys(values).map(name => {
            let filterRatePlan = Object.values(ratePlanList).find(item => item.name == name)
            filterRatePlan.active = values[name]
            updateRatePlans.push(filterRatePlan)
        })
        toggleUnsavedPage(true)
        setPreSavePage(updateRatePlans)
    }

    const savePageHandler = async () => {
        toggleUnsavedPage(false)

        let response = await savePage({object: objectId, section: "ratePlans", data: preSavePage})

        if(response) {

            if (targetRedirectLink) {
                history.push(targetRedirectLink)
            }
        }
    }



    if (!ratePlanList && !initValue) {
        return <Preloader loading={true} text="Загружаем тарифы"/>
    }
    return (
        <div className="main edit-object">
            <div className="container-fluid">

                <Formik onSubmit={onSubmit}
                        enableReinitialize
                        initialValues={initValue}>
                    {({handleSubmit, values}) => (
                        <Form onSubmit={handleSubmit}>
                            <Box className="alert alert-warning">
                                Выберите тарифные планы, доступные в вашем объекте
                            </Box>
                            <div className="row">
                                {values && Object.keys(values).map((item, index) => {
                                    return <Field key={item} type="checkbox" name={item}>
                                        {({field}) => {
                                            return <FormControlCheckBoxes key={item}
                                                                className="col-md-6"
                                                                label={item}
                                                                control={<GreenCheckbox {...field}/>}
                                            />
                                        }}

                                    </Field>

                                })}
                            </div>
                            <AutoSaveWithDebounce debounceMs={10} />
                        </Form>
                    )}
                </Formik>
            </div>
            {unsavedPage && <StickyBottomButton action={savePageHandler}/>}
            <AlertSavePage unsavedPage={unsavedPage} btnOkAction={savePageHandler}
                           setTargetRedirectLink={setTargetRedirectLink} targetRedirectLink={targetRedirectLink}/>
            <FunctionSidebarContainer/>
        </div>
    )
}


export default ObjectRatePlans;